module.exports = __webpack_public_path__ + "static/img/k1.93bc26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/k1.png
// module id = NAwy
// module chunks = 1